import styled from 'styled-components';
import { RootPortal } from '../../../common/RootPortal';
import { CommonButton } from '../../../common/CommonButton';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { USED_TICKET_MODAL_CONSTANTS } from '../../../../constants/usedTicketModal';
import { UsedTicketModalProps } from '../UsedTicketModal';

export const UsedTicketModalMobile = ({
  isVisibleCommon,
  commonCallback1,
  commonCallback2,
}: UsedTicketModalProps) => {
  const { getText } = useTextVariant(USED_TICKET_MODAL_CONSTANTS, true);

  return (
    <RootPortal>
      <ModalWrap $visible={isVisibleCommon}>
        <Dim />
        <ModalContent $visible={isVisibleCommon}>
          <Content>
            <ContentText>{getText('contentText')}</ContentText>
          </Content>

          <ButtonRowContainer>
            <CommonButton click={() => commonCallback2?.()} text={getText('cancelBtn') as string} theme={'dark'} />
            <CommonButton click={() => commonCallback1?.()} text={getText('confirmBtn') as string} />
          </ButtonRowContainer>
        </ModalContent>
      </ModalWrap>
    </RootPortal>
  );
};

const ButtonRowContainer = styled.div`
  width: 100%;
  position: absolute;
  left: 0;
  display: flex;

  > div:first-child {
    button {
      border-radius: 0;
      border-bottom-left-radius: 20px;
    }
  }

  > div:last-child {
    button {
      border-radius: 0;
      border-bottom-right-radius: 20px;
    }
  }
`;

const ModalWrap = styled.div<{ $visible: boolean }>`
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
`;

const ModalContent = styled.div<{ $visible: boolean }>`
  width: 90%;
  max-height: 80%;
  background: #302e2d;
  box-shadow: 0px 1px 1px 0px rgba(255, 255, 255, 0.2) inset;
  position: relative;
  z-index: 2;
  transform: ${({ $visible }) => ($visible ? 'scale(1)' : 'scale(0.75)')};
  transition: transform 0.15s ease-in-out;
  border-radius: 20px 20px 0px 0px;
`;

const Content = styled.div`
  height: 120px;
  border-radius: 8px;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: -0.3px;
`;
